module.exports = __webpack_public_path__ + "img/newMegaplier.d68df49e.jpg";